import axios from "axios";



const url= process.env.REACT_APP_BACKEND_URL



export const ChangePassowrd=async(data, setIsLoading, handleAlertOpen) => {
    setIsLoading(true);
    try{
        await axios.post(`${url}/auth/reset_password`,data,
            {
                headers:{
                    "Authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            }
        )
        .then((res)=>{
            setIsLoading(false);
            handleAlertOpen(res.data.message, "success");
            setTimeout(() => {
                sessionStorage.clear();
                window.location.href = '/';
            }, 2000);
            
        })
    }
    catch (error) {
        setIsLoading(false)
        handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong", "error");
    }
}